import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import companySlice from 'src/features/companySlice';
import deviceSlice from 'src/features/deviceSlice';
import manufacturerAccountSlice from 'src/features/manufacturerAccountSlice';
import productSlice from 'src/features/productSlice';
import serviceAccountSlice from 'src/features/serviceAccountSlice';
import ticketSlice from 'src/features/ticketSlice';
import { storageMiddleware } from 'src/store/middlewares/storageMiddleware';

import authReducer from '../features/authSlice';
import globalReducer from '../features/globalSlice';
import {
  watchAuth,
  watchCompany,
  watchDevice,
  watchGlobal,
  watchManufacturerAccount,
  watchProduct,
  watchServiceAccount,
  watchTicket,
} from '../store/sagas';

export const browserHistory = createBrowserHistory();

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const sagaMiddleware = createSagaMiddleware();
const routingMiddleware = routerMiddleware(browserHistory);

export const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    loadingBar: loadingBarReducer,
    ticket: ticketSlice,
    device: deviceSlice,
    product: productSlice,
    serviceAccount: serviceAccountSlice,
    manufacturerAccount: manufacturerAccountSlice,
    company: companySlice,
  },
  middleware: (defaultMiddleware) =>
    defaultMiddleware({ thunk: false, serializableCheck: false })
      .concat(sagaMiddleware)
      .concat(routingMiddleware)
      .concat(storageMiddleware),
  enhancers: [sentryReduxEnhancer],
});

sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchTicket);
sagaMiddleware.run(watchDevice);
sagaMiddleware.run(watchProduct);
sagaMiddleware.run(watchServiceAccount);
sagaMiddleware.run(watchGlobal);
sagaMiddleware.run(watchCompany);
sagaMiddleware.run(watchManufacturerAccount);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
